function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "arrow_6xon4hv10"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M324.9,250.3H16c-8.8,0-16-7.2-16-16c0-8.8,7.2-16,16-16h308.9c8.8,0,16,7.2,16,16C340.9,243.2,333.7,250.3,324.9,250.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M239.7,335.5c-4.1,0-8.2-1.6-11.3-4.7c-6.2-6.2-6.2-16.4,0-22.6l73.9-73.9l-73.9-73.9c-6.2-6.2-6.2-16.4,0-22.6 c6.2-6.2,16.4-6.2,22.6,0l85.2,85.2c6.2,6.2,6.2,16.4,0,22.6L251,330.8C247.9,334,243.8,335.5,239.7,335.5z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M255.7,468.7c-97,0-182.6-58.3-218.1-148.6c-3.2-8.2,0.8-17.5,9-20.7c8.2-3.2,17.5,0.8,20.7,9 c30.7,78,104.6,128.3,188.4,128.3c111.6,0,202.4-90.8,202.4-202.4S367.2,32,255.7,32C171.9,32,98,82.3,67.3,160.3 c-3.3,8.2-12.5,12.2-20.7,9c-8.2-3.2-12.2-12.5-9-20.7C73.1,58.3,158.7,0,255.7,0C384.9,0,490,105.1,490,234.3 S384.9,468.7,255.7,468.7z"
});

var SvgEnter = function SvgEnter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490 468.7",
    style: {
      enableBackground: "new 0 0 490 468.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/enter.b9483a35.svg";
export { ForwardRef as ReactComponent };